import { IntlShape, defineMessages } from 'react-intl';

import { TEventName, EventNameEnum } from '@/modules/journey/model';

const EVENTS = defineMessages<TEventName>({
  [EventNameEnum.on_the_way]: {
    defaultMessage: 'On the way',
    id: 'Mi6G3e',
    description: 'Journey event',
  },
  [EventNameEnum.arrived]: {
    defaultMessage: 'Arrived',
    id: 'KJ39fF',
    description: 'Journey event',
  },
  [EventNameEnum.serving]: {
    defaultMessage: 'Passenger on board',
    id: '8zmoNb',
    description: 'Journey event',
  },
  [EventNameEnum.done]: {
    defaultMessage: 'Done',
    id: '+kV9Ny',
    description: 'Journey event',
  },
  [EventNameEnum.cancelled]: {
    defaultMessage: 'Cancelled',
    id: 'G7yHtb',
    description: 'Journey event',
  },
  [EventNameEnum.failed]: {
    defaultMessage: 'Failed',
    id: 'bZv1Wh',
    description: 'Journey event',
  },
  [EventNameEnum.looking_for_drivers]: {
    defaultMessage: 'Looking for chauffeur',
    id: '/t/QLL',
    description: 'Journey event',
  },
  [EventNameEnum.extrastop]: {
    defaultMessage: 'Extrastop',
    id: '3hwXxL',
    description: 'Journey event',
  },
  [EventNameEnum.car_not_found]: {
    defaultMessage: 'Vehicle not found',
    id: 'nwutDs',
    description: 'Journey event',
  },
});

const renderEvent = (event: TEventName, intl: IntlShape): string => {
  if (event in EVENTS) {
    return intl.formatMessage(EVENTS[event]);
  }

  return '–';
};

export { renderEvent };
